import { Star } from "lucide-react";

const TESTIMONIALS = [
  {
    name: "Faith Ben",
    role: "Founder, Biztack",
    quote: "Brivo replaced 4 separate tools we were paying for. Inventory, payments, and reports all in one place — sales jumped 32% in two months.",
    img: "https://brivopos.com/images/site/faithw.png",
    accent: "bg-[#FFF9E6]",
  },
  {
    name: "Emeka E.",
    role: "Founder, Empire Tech.",
    quote: "Multi-warehouse stock transfers used to take a full day. With Brivo it's three clicks. The team is genuinely happier coming to work.",
    img: "https://brivopos.com/images/site/s1.jpg",
    accent: "bg-[#FFE4E8]",
  },
  {
    name: "Jovi Nero",
    role: "Owner, Earth & Honey",
    quote: "I used to dread reconciliation Sundays. Now Brivo Analytics tells me my best products before I even ask. It feels like having a CFO.",
    img: "https://brivopos.com/images/site/jov.jpg",
    accent: "bg-[#E8F5E9]",
  },
];

export default function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="relative py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-[#FFE4E8] text-black text-xs font-semibold mb-4">
            Loved by 12,000+ businesses
          </span>
          <h2 className="font-display text-4xl md:text-5xl font-extrabold text-black tracking-tight">
            Real businesses.<br /><span className="italic text-black/60">Real results.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {TESTIMONIALS.map((t, i) => (
            <div
              key={i}
              data-testid={`testimonial-${i}`}
              className={`${t.accent} rounded-3xl p-8 card-hover border border-[#12b571]/5 relative overflow-hidden`}
            >
              <div className="flex gap-0.5 mb-5">
                {[...Array(5)].map((_, j) => (
                  <Star key={j} size={16} className="fill-black text-black" />
                ))}
              </div>
              <p className="text-black text-lg leading-relaxed font-medium mb-8">"{t.quote}"</p>
              <div className="flex items-center gap-3 pt-6 border-t border-[#12b571]/10">
                <img src={t.img} alt={t.name} className="w-12 h-12 rounded-full object-cover" />
                <div>
                  <div className="font-semibold text-black">{t.name}</div>
                  <div className="text-sm text-black/60">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
